class ICoreTrustDashBars {
    static initialized = new WeakSet();

    constructor(root) {
        this.root = root;

        if (!this.root || ICoreTrustDashBars.initialized.has(this.root)) {
            return;
        }

        this.bars = [...this.root.querySelectorAll('.icore-trust-dash__bar-fill[data-bar]')];

        if (!this.bars.length) {
            return;
        }

        ICoreTrustDashBars.initialized.add(this.root);

        this.observer = new IntersectionObserver(
            (entries) => entries.forEach((entry) => this.#onIntersect(entry)),
            { threshold: 0.4 }
        );

        this.bars.forEach((bar) => this.observer.observe(bar));
    }

    #onIntersect(entry) {
        if (!entry.isIntersecting) {
            return;
        }

        const bar = entry.target;
        const percent = bar.dataset.bar;

        if (percent !== undefined && percent !== '') {
            bar.style.width = percent + '%';
        }

        this.observer.unobserve(bar);
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    static initById(rootId) {
        const root = document.getElementById(rootId);

        if (!root) {
            return null;
        }

        return new ICoreTrustDashBars(root);
    }

    static initAll() {
        document.querySelectorAll('[data-icore-trust-dash]').forEach((root) => {
            new ICoreTrustDashBars(root);
        });
    }
}

export default ICoreTrustDashBars;
